import { render, staticRenderFns } from "./TaxReturnFinancialActiveSection.vue?vue&type=template&id=6c324a26&scoped=true&"
import script from "./TaxReturnFinancialActiveSection.vue?vue&type=script&lang=js&"
export * from "./TaxReturnFinancialActiveSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c324a26",
  null
  
)

export default component.exports